import { useSessionProvider } from '@shared/composables/use-session-provider'
import EventBus, { PatientChatEvents } from '@shared/event-bus'
import { HttpStatus } from '@shared/models/enums/http'
import { isProd } from '@shared/utils/constants/app-mode'

import { ApiErrorCode } from '@protos/api_error_code_pb'

export const apiErrorCodeHandler = (apiErrorCode: ApiErrorCode) => {
  switch (apiErrorCode) {
    case ApiErrorCode.AUTH_INVALID_ACCESS_REFRESH_TOKENS_PAIR:
      if (isProd) {
        const { peerProps } = useSessionProvider()

        const host = peerProps.value?.apiHost ?? ''
        const page = `${host}/users/sign_in`

        window.location.replace(page)
      }
      break

    case ApiErrorCode.PC_TAC_SHOULD_BE_ACCEPTED:
      EventBus.emit(PatientChatEvents.redirectToTac)
      break

    default:
      break
  }
}

// export attempts for unit tests
export const attempts: { getTime: () => number }[] = []

// we use this method for preventing loop during refresh tocken
export const attemptRefreshToken = (error: HttpStatus) => {
  const now = Date.now()
  const halfMinuteAgo = now - 30000 // 30000 milliseconds = 30 sec

  // Check if there are at least two attempts
  if (attempts.length >= 2) {
    const lastAttempt = attempts[attempts.length - 1]?.getTime()
    const lastBeforeAttempt = attempts[attempts.length - 2]?.getTime()

    // Check if the last two attempts were within the last minute
    if (lastAttempt >= halfMinuteAgo && lastBeforeAttempt >= halfMinuteAgo) {
      if (isProd && error === HttpStatus.UNAUTHORIZED) {
        const { peerProps } = useSessionProvider()

        const host = peerProps.value?.apiHost ?? ''
        const page = `${host}/users/sign_in`

        window.location.replace(page)
        return false
      }
    }
  }

  const attemptDate = new Date()
  attempts.push(attemptDate)
  return true
}
